import React, { useState } from "react";
import {
  Button,
  Checkbox,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import EditText from "../../components/editText";

interface RsvpTableProps {
  category: string;
  statusFilter: string;
}

const RsvpTable: React.FC<RsvpTableProps> = ({ category, statusFilter }) => {
  const [expandedRowId, setExpandedRowId] = useState<number | null>(null);
  const [Employee, setEmployee] = useState("0");
  const [Status, setStatus] = useState("0");
  const navigate = useNavigate();

  const rows = [
    {
      id: 1,
      OfferName: "The Residence Tunis",
      BookingTime: "2nd-June-2025 | 6:00PM",
      Guests: "04",
      ClientName: "John Smith",
      ClientEmail: "john@gmail.com",
      ClientPhone: "+971 (0) 567894623",
      internalStatus: "New",
      EmployeeName: "John Smith",
      Category: "Dining",
    },
    {
      id: 2,
      OfferName: "The Residence Dubai",
      BookingTime: "3rd-June-2025 | 7:00PM",
      Guests: "02",
      ClientName: "Lily Adams",
      ClientEmail: "lily@gmail.com",
      ClientPhone: "+971 (0) 567894611",
      internalStatus: "In Progress",
      EmployeeName: "Emma Watson",
      Category: "Dining",
    },
    {
      id: 3,
      OfferName: "Dinner by the Beach",
      BookingTime: "4th-June-2025 | 8:00PM",
      Guests: "03",
      ClientName: "James Carter",
      ClientEmail: "james@gmail.com",
      ClientPhone: "+971 (0) 567894612",
      internalStatus: "Confirmed",
      EmployeeName: "Emily Rose",
      Category: "Dining",
    },
    {
      id: 4,
      OfferName: "Luxury Dinner Buffet",
      BookingTime: "5th-June-2025 | 9:00PM",
      Guests: "01",
      ClientName: "Nina Patel",
      ClientEmail: "nina@gmail.com",
      ClientPhone: "+971 (0) 567894613",
      internalStatus: "Completed",
      EmployeeName: "Michael Scott",
      Category: "Dining",
    },
    {
      id: 5,
      OfferName: "Wedding Event",
      BookingTime: "6th-June-2025 | 5:00PM",
      Guests: "10",
      ClientName: "Ethan Hunt",
      ClientEmail: "ethan@gmail.com",
      ClientPhone: "+971 (0) 567894614",
      internalStatus: "New",
      EmployeeName: "Steve Rogers",
      Category: "Event",
    },
    {
      id: 6,
      OfferName: "Corporate Meeting",
      BookingTime: "7th-June-2025 | 3:00PM",
      Guests: "06",
      ClientName: "Rachel Green",
      ClientEmail: "rachel@gmail.com",
      ClientPhone: "+971 (0) 567894615",
      internalStatus: "In Progress",
      EmployeeName: "Tony Stark",
      Category: "Event",
    },
    {
      id: 7,
      OfferName: "Music Concert",
      BookingTime: "8th-June-2025 | 7:00PM",
      Guests: "08",
      ClientName: "Phoebe Buffay",
      ClientEmail: "phoebe@gmail.com",
      ClientPhone: "+971 (0) 567894616",
      internalStatus: "Confirmed",
      EmployeeName: "Bruce Wayne",
      Category: "Event",
    },
    {
      id: 8,
      OfferName: "Annual Gala",
      BookingTime: "9th-June-2025 | 6:30PM",
      Guests: "05",
      ClientName: "Monica Geller",
      ClientEmail: "monica@gmail.com",
      ClientPhone: "+971 (0) 567894617",
      internalStatus: "Completed",
      EmployeeName: "Clark Kent",
      Category: "Event",
    },
    {
      id: 9,
      OfferName: "Desert Safari",
      BookingTime: "10th-June-2025 | 4:00PM",
      Guests: "0",
      ClientName: "Chandler Bing",
      ClientEmail: "chandler@gmail.com",
      ClientPhone: "+971 (0) 567894618",
      internalStatus: "New",
      EmployeeName: "Natasha Romanoff",
      Category: "Experience",
    },
    {
      id: 10,
      OfferName: "Helicopter Tour",
      BookingTime: "11th-June-2025 | 11:00AM",
      Guests: "0",
      ClientName: "Joey Tribbiani",
      ClientEmail: "joey@gmail.com",
      ClientPhone: "+971 (0) 567894619",
      internalStatus: "In Progress",
      EmployeeName: "Peter Parker",
      Category: "Experience",
    },
    {
      id: 11,
      OfferName: "Scuba Diving",
      BookingTime: "12th-June-2025 | 1:00PM",
      Guests: "0",
      ClientName: "Ross Geller",
      ClientEmail: "ross@gmail.com",
      ClientPhone: "+971 (0) 567894620",
      internalStatus: "Confirmed",
      EmployeeName: "Stephen Strange",
      Category: "Experience",
    },
    {
      id: 12,
      OfferName: "Hot Air Balloon Ride",
      BookingTime: "13th-June-2025 | 5:30AM",
      Guests: "0",
      ClientName: "Ted Mosby",
      ClientEmail: "ted@gmail.com",
      ClientPhone: "+971 (0) 567894621",
      internalStatus: "Completed",
      EmployeeName: "Barney Stinson",
      Category: "Experience",
    },
     {
      id: 13,
      OfferName: "Wedding Event",
      BookingTime: "6th-June-2025 | 5:00PM",
       Guests: "0",
      ClientName: "Ethan Hunt",
      ClientEmail: "ethan@gmail.com",
      ClientPhone: "+971 (0) 567894614",
      internalStatus: "New",
      EmployeeName: "Steve Rogers",
      Category: "Event",
    },
  ];
  const [legal3, setLegal3] = useState<string>("");

  const filteredRows = rows.filter((row) => {
    const categoryMatch = category === "All" || row.Category === category;
    const statusMatch =
      statusFilter === "All" || row.internalStatus === statusFilter;
    return categoryMatch && statusMatch;
  });

  const toggleExpand = (id: number) => {
    setExpandedRowId((prevId) => (prevId === id ? null : id));
  };

  return (
    <div className="table_container">
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>Booking ID</th>
            <th>Client Detail</th>
            <th>Offer Name</th>
            <th>Booking Time</th>
            {category !== "Experience" && <th>Guests</th>}

            <th>Category</th>
            <th>Employee Name</th>
            <th>Internal Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredRows.map((row) => (
            <React.Fragment key={row.id}>
              <tr>
                <td
                  className="cursor_p"
                  onClick={() =>
                   navigate(`/manage-booking-resvp/booking-detail?category=${row.Category}`)
                  }
                >
                  {row.id}
                </td>
                <td className="max_c2">
                  {row.ClientName}
                  <br />
                  <small>{row.ClientPhone}</small>
                </td>
                <td
                  className="cursor_p max_c2"
                  onClick={() =>
                    navigate(`/manage-booking-resvp/booking-detail?category=${row.Category}`,{state:{count:row.Guests}})
                  }
                >
                  {row.OfferName}
                </td>
                <td className="max_c2">
                  <p
                    onClick={() => toggleExpand(row.id)}
                    className="text_btn cursor_p"
                  >
                    {row.BookingTime}
                  </p>
                </td>
             {category !== "Experience" && <td>{row.Guests}</td>}

                <td>{row.Category}</td>
                <td>{row.EmployeeName}</td>
                <td>{row.internalStatus}</td>
              </tr>

              {expandedRowId === row.id && (
                <tr>
                  <td colSpan={8}>
                    <div className="expanded-content">
                      <div className="form_flex">
                        <div className="w_100">
                          <div className="control_group mb_0 employee_list">
                            <Select
                              value={Employee}
                              onChange={(e: SelectChangeEvent) =>
                                setEmployee(e.target.value)
                              }
                            >
                              <MenuItem value="0" disabled>
                                Employee Listing
                              </MenuItem>
                              <MenuItem value="10">Adam Smith</MenuItem>
                              <MenuItem value="20">Denny Juan</MenuItem>
                              <MenuItem value="30">Hermanto</MenuItem>
                            </Select>
                          </div>

                          <Select
                            value={Status}
                            onChange={(e: SelectChangeEvent) =>
                              setStatus(e.target.value)
                            }
                            className="booking_status"
                          >
                            <MenuItem value="0" disabled>
                              Status
                            </MenuItem>
                            <MenuItem value="10">New</MenuItem>
                            <MenuItem value="20">In Progress</MenuItem>
                            <MenuItem value="30">Pending Venue</MenuItem>
                            <MenuItem value="40">Pending Member</MenuItem>
                            <MenuItem value="50">Confirmed</MenuItem>
                            <MenuItem value="60">Cancelled</MenuItem>
                          </Select>

                          <div className="control_group add_note">
                            <TextField
                              placeholder="Add Notes"
                              hiddenLabel
                              fullWidth
                            />
                          </div>

                          <Button className="btn btn_primary">Save</Button>
                        </div>

                        <div className="w_100">
                          <Checkbox /> Assign to me
                        </div>

                        {row.Category === "Experience" && (
                          <>
                            <div className="w_100" style={{alignItems:"flex-start"}}>
                              <div className="control_group w_50">
                                <TextField
                                  placeholder="Amount"
                                  hiddenLabel
                                  fullWidth
                                />
                              </div>
                              <div className="control_group w_50">
                                <div className="control_group w_100">
                                  <EditText
                                    content={legal3}
                                    setContent={setLegal3}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RsvpTable;
